import { render, staticRenderFns } from "./orders-statistics.vue?vue&type=template&id=64a74b30&scoped=true&"
import script from "./orders-statistics.js?vue&type=script&lang=js&"
export * from "./orders-statistics.js?vue&type=script&lang=js&"
import style0 from "./orders-statistics.scss?vue&type=style&index=0&id=64a74b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a74b30",
  null
  
)

export default component.exports